'use strict';

var angularModule = angular.module('t2g.common.directives', [
  require('./autoExpandDirective').name,
  require('./autoFillFixDirective').name,
  require('./capitalizeDirective').name,
  require('./colorPickerDirective').name,
  require('./confirmButtonDirective').name,
  require('./fab').name,
  require('./fakeClickDirective').name,
  require('./focusDirective').name,
  require('./horizontalFixedDirective').name,
  require('./menuDirective').name,
  // require('./moneyMaskDirective').name,
  require('./navigationDirective').name,
  require('./numberInputDirective').name,
  require('./offCanvas').name,
  require('./onEnterDirective').name,
  require('./onResizeDirective').name,
  require('./onScrollDirective').name,
  require('./pwCheckDirective').name,
  require('./priceInputDirective').name,
  require('./radioButtonDirective').name,
  require('./stateTitleDirective').name,
  require('./tabLinkDirective').name,
  require('./timePickerDirective').name,
  require('./trackErrosDirective').name,
  require('./toggleLabelDirective').name,
  require('./wavesDirective').name,
  require('./wysiwygDirective').name,
]);

module.exports = angularModule;



// WEBPACK FOOTER //
// ./src/app/common/directives/index.js